import { UseFormReturn } from "react-hook-form"
import { Property, ScenarioNode } from "@/gen"
import Combobox from "@/components/ui/combobox"
import { Button } from "@/components/ui/button"
import { DrawerLabelField } from "../SwitchCollapseInput"
import TooltipLabel from "@/components/feedback/TooltipLabel"
import { Separator } from "@/components/ui/separator"
import FormBuilder from "."

export interface OptionalPropertiesProps {
  //   properties?: Property[]
  label?: string
  tip?: string
  form: UseFormReturn<any, any, undefined>
  meta_properties: ScenarioNode["meta_properties"]
  optionalProperties: Property[]
  node_type: string
  action_id?: string
  operation_id?: string
}

function OptionalProperties(props: OptionalPropertiesProps) {
  const visibleProperties = props.optionalProperties.filter((property: any) => !!props.meta_properties?.[property.id]?.visible) || []

  const hiddenProperties = props.optionalProperties.filter((property: any) => !props.meta_properties?.[property.id]?.visible) || []

  const options = hiddenProperties?.map((property: any) => ({ label: property.label, value: property.id, badge: property.badge })) || []

  return (
    <>
      <Separator className="opacity-50" />
      <div className="flex flex-col gap-4">
        <DrawerLabelField label={<TooltipLabel tip={props.tip}>{props.label}</TooltipLabel>}>
          {visibleProperties.length > 0 && (
            <FormBuilder
              properties={visibleProperties}
              form={props.form}
              deleteable
              node_type={props.node_type}
              action_id={props.action_id}
              operation_id={props.operation_id}
            />
          )}
          <Combobox
            fluid
            options={options}
            onChange={(value) => {
              props.form.setValue(`meta_properties.${value}.visible`, true)
            }}
          >
            <Button variant="secondary">
              {/* <div className="size-4 rounded-full fc bg-primary text-white"> */}
              <IconHugeiconsPlusSign className="size-3 [&_path]:stroke-3" />
              {/* </div> */}
              Property
            </Button>
          </Combobox>
        </DrawerLabelField>
      </div>
    </>
  )
}

export default OptionalProperties
